import script from "./switch.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./switch.vue?vue&type=script&lang=ts&setup=true"
export * from "./switch.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./switch.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__